export default __webpack_public_path__ + "static/media/PolySansTrial-Bulky.2a13c7a7.otf";